module.exports = __webpack_public_path__ + "img/Slide37.63e2371f.png";